function isTruthyFlag (value) {
  return value === true || value === 1 || value === '1' || value === 'true'
}

/**
 * @param {object|null|undefined} group
 * @returns {boolean}
 */
export function isChatGroupActive (group) {
  if (!group?.id) return false
  if (group.isActive === false || group.is_active === false) return false
  if (group.isDeleted === true || group.is_deleted === true) return false
  if (isTruthyFlag(group.deleted) || isTruthyFlag(group.isDeleted) || isTruthyFlag(group.is_deleted)) return false
  return true
}

/**
 * @param {object|null|undefined} group
 * @returns {boolean}
 */
export function isChatGroupDeleted (group) {
  return !!group?.id && !isChatGroupActive(group)
}
